import React, { useState } from 'react'
import Select from 'react-select'
import moment from 'moment'
import { Drawer, Tabs } from 'antd'
import { AiOutlineDelete } from 'react-icons/ai'

import Datepicker from "../reusable/datePicker"

import { usePet, useToggle, useListData, normalize, notifOps } from '../../modules'
import SelectLabel from '../reusable/selectLabel'
import Confirm from '../reusable/confirm'
import { useSnackbar } from 'notistack'

const { TabPane } = Tabs

let entrySubjectTypes = ['Patient', 'Supplier', 'Other']

const NewJournal = ({ toggle, visible, onPerform }) => {
    const [notes, setNotes] = useState()
    const [date, setDate] = useState(moment())
    const [methods, setMethods] = useState([])
    const [transactions, setTransactions] = useState([])
    const [accounts, setAccounts] = useState([])

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    
    const close = () => toggle()
    
    const [,
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('accounts', {}, { notify: true, manual: false }, 'accounts', 100, ({ accounts: data }) => {
        let obj = {}
        
        data.forEach(acc => {
            if (!obj[acc.type])
                obj[acc.type] = []

            obj[acc.type].push({
                label: acc.name,
                value: acc._id
            })
        })

        let final = []
        for (let typ in obj)
            final.push({
                label: typ,
                options: obj[typ]
            })

        setAccounts(final)
    })

    const onComplete = ({ data }, notif, ops) => {
        onPerform()
        notif('Journal Entry has been created', ops('success'))
        
        setTimeout(close, 300)
    }

    usePet('paymentMethodNames', null, { notify: true, callback: ({ data }) => setMethods(data) })

    const [{ loading }, execute] = usePet('newJournalEntry', {
        date, 
        notes,
        transactions: transactions.map(({ account, description, credit, debit }) => ({
            account: account?.value,
            description,
            credit,
            debit
        }))
    }, { notify: true, callback: onComplete, manual: true })

    const newItm = () => setTransactions(trans => [...trans, { credit: 0, debit: 0 }])

    let debits = normalize(transactions?.reduce((total, trans) => total + Number(trans.debit), 0))
    let credits = normalize(transactions?.reduce((total, trans) => total + Number(trans.credit), 0))

    const modify = (val, key, index) => {
        if ((key === 'debit' || key === 'credit')) {
            if (val < 0) {
                enqueueSnackbar('Negative values are not allowed', notifOps('warning'))
                return
            } else if (isNaN(val)) {
                enqueueSnackbar('Only numberical values are accepted', notifOps('warning'))
                return
            }
        }

        let x = [...transactions]

        x[index][key] = val

        if (key === 'debit')
            x[index]['credit'] = 0
        else if (key === 'credit')
            x[index]['debit'] = 0

        console.log({ d: x[index], val, key, index })

        setTransactions(x)
    }

    const removeItem = index => {
        let x = [...transactions]
        x = x.filter((_, i) => i !== index)
        setTransactions(x)
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={ () => Confirm({
                        title: 'Create New Journal Entry?',
                        message: `This will affect the books of accounts values.`,
                        onOk: () => {
                            if (debits !== credits)
                                enqueueSnackbar('Please ensure that debits and credits are equal', notifOps('warning'))
                            else
                                execute()
                        },
                        okText: 'Create New Entry',
                    }) } className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Record Entry</button>
                </div>
            }
            width="50%">
            <p className="font-extrabold text-3xl mb-0">New Journal Entry</p>
            <div className="flex flex-wrap mt-3">
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Date
                    </label>
                    <Datepicker value={date} onChange={setDate} />
                </div>
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Notes
                    </label>
                    <textarea
                        rows={ 4 }
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-notes"
                        name="notes"
                        value={notes}
                        onChange={ e => setNotes(e.target.value) }
                        placeholder="Notes..." />
                </div>
                {
                    transactions?.length > 0 ?
                        <table className="table-auto w-full mx-3 mt-3">
                            {/* Table header */}
                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                <tr>
                                    <th className="p-2">
                                        <div className="font-semibold text-center">No</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Account</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-center">Description</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-center">Credit</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-center">Debit</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-center"></div>
                                    </th>
                                </tr>
                            </thead>
                            {/* Table body */}
                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                {/* Row */}
                                {
                                    transactions?.map((trans, key) =>
                                        <tr>
                                            <td className="p-2">
                                                <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                            </td>
                                            <td className="p-2">
                                                <Select
                                                    className="mb-3"
                                                    options={accounts}
                                                    value={ trans?.account }
                                                    placeholder="Account"
                                                    formatGroupLabel={ SelectLabel }
                                                    styles={{ input: styles => ({ ...styles, maxWidth: '3.5em' }) }}
                                                    onChange={ val => modify(val, 'account', key) } />
                                            </td>
                                            <td className="p-2">
                                                <input
                                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                                    id={ `grid-desc-${key}` }
                                                    name={ `desc-${key}` }
                                                    value={ trans?.desc }
                                                    onChange={ e => modify(e.target.value, 'desc', key) }
                                                    type="text"
                                                    placeholder="Description" />
                                            </td>
                                            <td className="p-2">
                                                <input
                                                    className="appearance-none block w-28 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                                    id={ `grid-credit-${key}` }
                                                    name={ `credit-${key}` }
                                                    value={ trans?.credit }
                                                    onChange={ e => modify(e.target.value, 'credit', key) }
                                                    type="number" />
                                            </td>
                                            <td className="p-2">
                                                <input
                                                    className="appearance-none block w-28 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                                    id={ `grid-debit-${key}` }
                                                    name={ `debit-${key}` }
                                                    value={ trans?.debit }
                                                    onChange={ e => modify(e.target.value, 'debit', key) }
                                                    type="number" />
                                            </td>
                                            <td className="p-2 text-center">
                                                <button onClick={ () => removeItem(key) } className="btn ml-2 py-1 shadow-none bg-red-100 hover:bg-red-200 hover:text">
                                                    <AiOutlineDelete className='font-base' />
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    :
                        <div className="w-full h-16 text-center mt-3">
                            <div className="font-semibold w-full text-base">Please click below to add a new journal entry</div>
                        </div>
                }
                <div className="w-full h-16 text-center mb-1">
                    <button onClick={ newItm } className="btn px-3 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text">Add New Item</button>
                </div>
                <div className="flex flex-col items-end pr-3 py-3 w-full">
                    <p className="font-semibold text-lg underline mb-2">Overview</p>
                    <p className={ `mb-1 ${ debits < 0 ? 'text-red-500' : '' }` }>Debits: Ksh. { debits }</p>
                    <p className={ `mb-1 ${ credits < 0 ? 'text-red-500' : '' }` }>Credits: Ksh. { credits }</p>
                    <p className={ `mb-1 ${ debits !== credits ? 'text-red-500' : '' }` }>Difference: Ksh. { Math.abs(debits - credits) }</p>
                </div>
            </div>
        </Drawer>
    )
}

export default NewJournal